import { COMPLETED_STATUSES } from './enum';

export const isSubstepCompleted = (orchestratorData) =>
  COMPLETED_STATUSES.includes(orchestratorData?.handlerStatus);

// Single source of truth for what the onboarding footer Continue button does.
// Ordering matters: a dirty form must save (and re-evaluate) even on a completed
// substep, a completed substep must NOT re-hit the orchestrator (updateSubstepStatus
// patches status blindly, so a stray re-call can downgrade Completed/Confirmed),
// and pre-existing unchanged data on an incomplete substep still needs one
// orchestrator call to ever be marked complete.
export const resolveContinueAction = ({
  isDirty,
  isCompleted,
  hasExistingData,
  onSave,
  onConfirm,
  onNext
}) => {
  if (isDirty) return onSave;
  if (isCompleted) return onNext;
  if (hasExistingData) return onConfirm;
  return onNext;
};
